import { createSchema } from '../../common/inputSchemas/document';
import { buildAttributeSchema } from '../lib/buildAttributeSchema';
import { createSaveHandler } from '../lib/createSaveHandler';
import { trpc } from '../lib/trpc';
import withParams from '../lib/withParams';
import { Form, type FormFields } from './Form';
import { zodResolver } from '@hookform/resolvers/zod';
import { invariant } from 'es-toolkit';
import { use } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'wouter';
import { z } from 'zod';

export const New = withParams(
  ({ id }) => {
    const [, navigate] = useLocation();
    const modelData = use(
      trpc.models.show.useQuery(id, {
        experimental_prefetchInRender: true,
      }).promise,
    );
    const { mutateAsync: createDocumentAsync } =
      trpc.documents.create.useMutation();
    invariant(modelData, 'modelData is empty');
    const schema = z
      .object({
        attributes: buildAttributeSchema(modelData.schema.fields),
      })
      .extend(createSchema.pick({ slug: true, title: true }).shape);
    const form = useForm<FormFields>({
      defaultValues: {
        attributes: {},
        slug: '',
        title: '',
      },
      resolver: zodResolver(schema),
    });

    const submitHandler = createSaveHandler(
      form,
      (data) =>
        createDocumentAsync({
          attributes: data.attributes,
          modelId: id,
          slug: data.slug || '',
          title: data.title,
        }),
      () => navigate('/content'),
    );

    return (
      <FormProvider {...form}>
        <Form
          modelData={modelData}
          submitHandler={submitHandler}
          title={`New ${modelData.name}`}
        />
      </FormProvider>
    );
  },
  z.object({ id: z.string() }),
);
